export default "__VITE_ASSET__BfVoyx9I__"